import React from 'react';
import classes from './header.module.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png'
import SocialLinks from '../social/SocialLinks';
import { getCategoryPagePath } from '../../../config/serviceCategories';
import head from '../../images/head.png'
import beard from '../../images/beard.png'
import brows from '../../images/brows.png'
import nails from '../../images/nails.png'
import care from '../../images/care.png'
import MediaQuery from 'react-responsive'

const IconPin = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none" className={classes.icon}>
        <path fillRule="evenodd" clipRule="evenodd" d="M8 0C4.07456 0 1.21992 2.65655 0.150936 6.66667C-1.2852 12.0541 8 20 8 20C8 20 17.2852 12.0541 15.8491 6.66667C14.7801 2.65655 11.9254 0 8 0ZM8 10.8333C9.76731 10.8333 11.2 9.34095 11.2 7.5C11.2 5.65905 9.76731 4.16667 8 4.16667C6.23269 4.16667 4.8 5.65905 4.8 7.5C4.8 9.34095 6.23269 10.8333 8 10.8333Z" fill="#E0ECFB"/>
    </svg>
);

const IconClock = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={classes.icon}>
        <path fillRule="evenodd" clipRule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10.8342 10.8333H15.8333C15.8333 10.8333 16.6667 10.8333 16.6667 10C16.6667 9.16667 15.8333 9.16667 15.8333 9.16667H10.8346L10.8333 4.16667C10.8333 4.16667 10.8346 3.33333 10 3.33333C9.16545 3.33333 9.16667 4.16667 9.16667 4.16667L9.16758 9.16697C9.16775 10.0873 9.91389 10.8333 10.8342 10.8333Z" fill="#E0ECFB"/>
    </svg>
);

const IconBlog = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" className={classes.icon}>
        <path fillRule="evenodd" clipRule="evenodd" d="M0.315423 12.9467C2.06094 9.50631 5.59338 2.54759 5.75897 2.23554C5.96594 1.84547 6.18327 1.77167 6.52479 1.77167C6.8663 1.77167 8.33585 2.01415 10.7058 1.67679C13.0757 1.33943 15.1041 0.422237 15.5905 0.127048C16.0769 -0.168141 16.5943 0.0954206 16.6978 0.464406C16.8013 0.833392 16.7288 1.02316 16.584 1.34997C16.468 1.61142 15.8181 3.13165 15.5077 3.85907C15.6939 3.90827 16.1555 4.00878 16.5115 4.01721C16.9565 4.02775 17.5671 3.92233 17.7844 4.33348C18.0018 4.74464 17.8362 5.12417 17.6189 5.55641C17.445 5.9022 17.1394 6.56497 17.0083 6.85313C17.1876 6.89178 17.6064 6.97331 17.8465 6.99018C18.1466 7.01127 18.7158 6.92693 18.8918 7.30645C19.0677 7.68598 19.0263 7.83358 18.7883 8.4345C18.5503 9.03542 13.976 19.2616 13.8725 19.5462C13.769 19.8309 13.6966 20.0101 12.9101 19.9996C12.1236 19.989 9.7847 19.8203 6.55583 19.0824C3.32696 18.3444 1.0295 17.0793 0.315423 15.5612C-0.255838 14.3467 0.0773974 13.3121 0.315423 12.9467ZM11.6165 12.9467C11.7158 12.6852 13.8311 7.73518 14.8764 5.29285C15.2582 5.4497 15.4908 5.46701 15.9636 5.5022L15.9837 5.5037L11.1818 15.6772C10.6402 15.6947 9.06648 15.6708 7.02153 15.519C4.97658 15.3672 3.38216 14.8373 2.84056 14.5702C3.44425 14.6721 5.09456 14.8359 6.99049 14.76C9.33799 14.666 10.5279 13.9617 10.862 13.764L10.8713 13.7584C11.1922 13.5687 11.4923 13.2735 11.6165 12.9467ZM7.67352 17.1215C5.79415 17.0118 4.17213 16.6471 3.59603 16.4784C6.26774 17.5966 8.30573 18.0136 12.7031 18.4604L17.1531 8.4345C16.7619 8.38943 16.5908 8.34733 16.3666 8.24473C15.0696 10.9893 12.4527 16.5332 12.3616 16.7525C12.2477 17.0266 11.9476 17.1742 11.7303 17.1953C11.513 17.2164 10.0227 17.2585 7.67352 17.1215Z" fill="#FEC708"/>
    </svg>
);

const IconHead = () => (
  <img src={head} alt="head" className={classes.icon2}/>
);

const IconBeard = () => (
  <img src={beard} alt="beard" className={classes.icon2}/>
);

const IconBrows = () => (
  <img src={brows} alt="brows" className={classes.icon2}/>
);

const IconNails = () => (
  <img src={nails} alt="nails" className={classes.icon2}/>
);

const IconCare = () => (
  <img src={care} alt="care" className={classes.icon2}/>
);

const IconPhone = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none" className={classes.icon}>
        <path d="M7.79005 5.76547C7.74616 5.23374 7.40595 3.6607 7.24134 2.94065C7.13161 2.44216 6.8902 1.36762 6.80241 1.05745C6.69267 0.669726 6.30857 0.0604533 5.26602 0.0050648C4.22347 -0.0503237 2.35782 0.337396 1.2604 1.72211C0.16298 3.10682 -0.440603 5.15619 0.382464 7.75945C1.20553 10.3627 3.12602 13.8522 6.14393 16.8432C9.16184 19.8341 11.9054 21.9389 14.2649 21.9943C16.6243 22.0497 17.6669 21.7173 18.7643 20.3326C19.8617 18.9479 19.9715 17.4524 19.9715 17.2863C19.9715 17.1201 20.2458 16.6216 19.0935 16.0123C17.9412 15.4031 15.6366 14.4615 15.0331 14.2399C14.4295 14.0183 13.9356 14.1291 13.7161 14.4061C13.4967 14.683 13.1126 15.2369 12.8382 15.68C12.5639 16.1231 12.1798 16.2339 11.6859 16.0123C11.1921 15.7908 8.88749 14.1291 7.51571 12.3013C6.14393 10.4735 5.54034 8.81183 5.43059 8.42411C5.32085 8.03639 5.37572 7.64867 5.75982 7.48251C6.14392 7.31634 6.58289 7.15018 7.02186 6.92862C7.46083 6.70707 7.84492 6.43013 7.79005 5.76547Z" fill="#A6851C"/>
    </svg>
);

const Header = ({ onServiceClick }) => {
  const handleServiceCategoryClick = (categoryId) => {
    if (onServiceClick) {
      onServiceClick(categoryId);
      return;
    }
    const path = getCategoryPagePath(categoryId);
    window.location.href = path || '/#prices';
  };

  return (
    <header className={classes.root}>
      <div className={classes.topBarOuter}>
        <div className={classes.fon1}></div>
        <div className={classes.topBar}>
          <div className={classes.topLeft}>
            <span className={classes.infoItem}>
              <IconPin />
              Москва, Смоленский бульвар, 22/14
            </span>
            <span className={classes.infoItem}>
              <IconClock />
              пн.-вс.: 10:00-21:00
            </span>
          </div>
          <nav className={classes.topRight}>
            <a href="/#certificates" className={classes.navLink}>Сертификаты</a>
            <a href="/#about" className={classes.navLink}>О салоне</a>
            <a href="/blog/" className={classes.navLink}>
                <span className={classes.navIconBlog}><IconBlog/></span>
                Блог
            </a>
            <a
                href="https://widget.sonline.su/ru/services/?placeid=852816903"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.navLink}
            >
            Записаться онлайн
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                  <circle cx="10.5" cy="10.5" r="10.5" fill="#062703"/>
                  <circle cx="10.5" cy="10.5" r="5.5" fill="#0B4306"/>
                  <circle cx="10.5" cy="10.5" r="2.5" fill="#3FD332"/>
              </svg>
            </a>
            <SocialLinks
              variant="header"
              className={classes.social}
              linkClassName={classes.socialLink}
              iconClassName={classes.icon}
            />
          </nav>
        </div>
      </div>

      <div className={classes.fon2}></div>
      <div className={classes.mainBar}>
        <div className={classes.brand}>
          <Link to="/" className={classes.logo}>
            <img src={logo} className={classes.logoImg} alt="logo"/>
          </Link>
          <p className={classes.tagline}>
            Территория мужского ухода, <br/> где стиль начинается с деталей.
          </p>
        </div>
          <div className={classes.mainBarRight}>
              <MediaQuery minWidth={1200}>
                  <nav className={classes.services}>
                      <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('head')}>
                          <IconHead/>
                          <span>Стрижки</span>
                      </div>
                      <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('beard')}>
                          <IconBeard/>
                          <span>Борода</span>
                      </div>
                      <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('brows')}>
                          <IconBrows />
                          <span>Брови</span>
                      </div>
                      <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('nails')}>
                          <IconNails />
                          <span>Ногтевой<br /> сервис</span>
                      </div>
                      <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('care')}>
                          <IconCare />
                          <span>Уход</span>
                      </div>
                  </nav>
              </MediaQuery>
              <a href="tel:+79151897033" className={classes.phoneBtn}>
                  <IconPhone />
                  +7 915 189-70-33
              </a>
          </div>
      </div>
        <MediaQuery maxWidth={1199}>
            <nav className={classes.services}>
                <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('head')}>
                    <IconHead/>
                    <span>Стрижки</span>
                </div>
                <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('beard')}>
                    <IconBeard/>
                    <span>Борода</span>
                </div>
                <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('brows')}>
                    <IconBrows/>
                    <span>Брови</span>
                </div>
                <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('nails')}>
                    <IconNails/>
                    <span>Ногтевой<br/> сервис</span>
                </div>
                <div className={classes.serviceItem} onClick={() => handleServiceCategoryClick('care')}>
                    <IconCare/>
                    <span>Уход</span>
                </div>
            </nav>
        </MediaQuery>
    </header>
  );
};

export default Header;
